export const PERMIT_ALREADY_RENEWED = 'Permit is already renewed';
